<app-crear-editar
  [loading]="loading || !form"
  [title]="title"
  [subtitle]="subtitle"
  [icono]="icono"
>
  @if (form) {
    <form [formGroup]="form" autocomplete="off" class="dashcam-form">
      <div class="form-pasos-layout">
        <app-pasos-nav
          [stepper]="stepper"
          etiqueta="Pasos de la dashcam"
        ></app-pasos-nav>

        <mat-stepper #stepper [linear]="false" class="form-pasos-stepper">
          <!-- ── 1. Datos ─────────────────────────────────────────────── -->
          <mat-step [stepControl]="datos" errorMessage="Campos incompletos">
            <ng-template matStepLabel>Datos</ng-template>
            <app-content-card title="Datos" [icon]="icono" [formGroup]="datos">
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Nombre</mat-label>
                  <input matInput formControlName="nombre" required />
                  <mat-icon matPrefix>label</mat-icon>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Identificación</mat-label>
                  <input matInput formControlName="identificacion" />
                  <mat-icon matPrefix>badge</mat-icon>
                </mat-form-field>
              </section>

              <section class="inputs-group">
                <div style="width: 100%">
                  <label class="field-label">Modelo</label>
                  <app-modelo-dispositivo-selector
                    tipo="Dashcam"
                    formControlName="idModelo"
                    [showCrearBtn]="
                      helper.tienePermiso(
                        'Configuraciones - Crear modelos dashcams'
                      )
                    "
                  ></app-modelo-dispositivo-selector>
                </div>
              </section>

              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>ID único</mat-label>
                  <input
                    matInput
                    formControlName="uniqueId"
                    inputmode="numeric"
                    required
                  />
                  <mat-icon matPrefix>fingerprint</mat-icon>
                  <mat-hint>
                    Es el
                    <em>SIM CardNumber</em>
                    configurado en la cámara, sin ceros a la izquierda.
                  </mat-hint>
                  <mat-error>Sólo números, sin ceros a la izquierda.</mat-error>
                </mat-form-field>

                <mat-form-field style="width: 100%">
                  <mat-label>Número de serie</mat-label>
                  <input matInput formControlName="numeroSerie" />
                  <mat-icon matPrefix>qr_code</mat-icon>
                </mat-form-field>
              </section>
            </app-content-card>
          </mat-step>

          <!-- ── 2. Comunicación ──────────────────────────────────────── -->
          <mat-step [stepControl]="comunicacion" optional>
            <ng-template matStepLabel>Comunicación</ng-template>
            <app-content-card
              title="Comunicación"
              icon="cell_tower"
              [formGroup]="comunicacion"
            >
              <section class="inputs-group">
                <mat-form-field style="width: 100%">
                  <mat-label>Frecuencia de reporte (minutos)</mat-label>
                  <input
                    matInput
                    formControlName="frecReporte"
                    type="number"
                    min="1"
                  />
                  <mat-icon matPrefix>timer</mat-icon>
                  <mat-hint>
                    Cada cuánto se espera un reporte. Con ella se calcula si la
                    dashcam está en línea.
                  </mat-hint>
                </mat-form-field>
              </section>
            </app-content-card>

            <div class="dashcam-sims">
              <app-sim-config
                [formGroup]="sim1"
                title="SIM 1"
                [idExcluir]="id"
              ></app-sim-config>
              <app-sim-config
                [formGroup]="sim2"
                title="SIM 2"
                [idExcluir]="id"
              ></app-sim-config>
            </div>
          </mat-step>

          <!-- ── 3. Video ─────────────────────────────────────────────── -->
          <mat-step [stepControl]="video" errorMessage="Revisá los canales">
            <ng-template matStepLabel>Video</ng-template>
            <app-content-card
              title="Canales de video"
              icon="view_module"
              [formGroup]="video"
            >
              <table class="dashcam-canales">
                <thead>
                  <tr>
                    <th class="col-numero">Canal</th>
                    <th>Nombre</th>
                    <th>Función</th>
                    <th class="col-check">Habilitado</th>
                    <th class="col-check">Audio</th>
                    <th class="col-accion"></th>
                  </tr>
                </thead>
                <tbody formArrayName="canales">
                  @for (
                    canal of canales.controls;
                    track canal;
                    let i = $index
                  ) {
                    <tr [formGroupName]="i">
                      <td class="col-numero">
                        <mat-form-field class="no-hint">
                          <input
                            matInput
                            type="number"
                            min="1"
                            formControlName="numero"
                            aria-label="Número de canal"
                          />
                        </mat-form-field>
                      </td>
                      <td>
                        <mat-form-field class="no-hint">
                          <input
                            matInput
                            formControlName="nombre"
                            aria-label="Nombre del canal"
                          />
                        </mat-form-field>
                      </td>
                      <td>
                        <ng-select
                          [items]="funciones"
                          formControlName="funcion"
                          placeholder="Función"
                          appendTo="body"
                          notFoundText="Sin resultados"
                        ></ng-select>
                      </td>
                      <td class="col-check">
                        <mat-checkbox
                          color="primary"
                          formControlName="habilitado"
                          aria-label="Habilitado"
                        ></mat-checkbox>
                      </td>
                      <td class="col-check">
                        <mat-checkbox
                          color="primary"
                          formControlName="audio"
                          aria-label="Audio"
                        ></mat-checkbox>
                      </td>
                      <td class="col-accion">
                        <button
                          irxBotonIcono
                          type="button"
                          tono="peligro"
                          tooltip="Quitar canal"
                          (click)="quitarCanal(i)"
                        >
                          <mat-icon>delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="6" class="no-info">Sin canales cargados</td>
                    </tr>
                  }
                </tbody>
              </table>

              @if (canalesRepetidos) {
                <small class="ayuda dashcam-error">
                  Hay dos canales con el mismo número.
                </small>
              }
              <small class="ayuda">
                Sólo los canales habilitados se ofrecen para ver en vivo y para
                buscar grabaciones.
              </small>

              <section class="inputs-group">
                <button
                  irxBoton="secundario"
                  type="button"
                  (click)="agregarCanal()"
                >
                  <mat-icon>add</mat-icon>
                  Agregar canal
                </button>
              </section>
            </app-content-card>

            <app-content-card
              title="Ajustes de video"
              icon="tune"
              [formGroup]="video"
            >
              <section class="inputs-group">
                <div style="width: 100%">
                  <ng-select
                    formControlName="flujoEnVivo"
                    placeholder="Calidad para ver en vivo"
                    [items]="flujos"
                    bindValue="valor"
                    bindLabel="etiqueta"
                    [clearable]="false"
                    appendTo="body"
                    notFoundText="Sin resultados"
                  ></ng-select>
                  <small class="ayuda">
                    La cámara graba en dos calidades. La secundaria alcanza para
                    ver en vivo y gasta mucho menos de la SIM.
                  </small>
                </div>

                <mat-form-field style="width: 100%">
                  <mat-label>Duración máxima en vivo (minutos)</mat-label>
                  <input
                    matInput
                    type="number"
                    min="1"
                    formControlName="duracionMaximaMinutos"
                  />
                  <mat-icon matPrefix>timer_off</mat-icon>
                  <mat-hint>
                    Pasado este tiempo, la transmisión en vivo se corta sola.
                  </mat-hint>
                </mat-form-field>
              </section>

              <section class="inputs-group" style="flex-direction: column">
                <mat-checkbox
                  color="primary"
                  formControlName="solicitarEvidencia"
                >
                  Pedir evidencias automáticamente
                </mat-checkbox>
                <small class="ayuda">
                  Cuando la cámara avisa una alarma con fotos o video, se
                  descargan solos. Consume datos móviles de la SIM: si el plan
                  es chico, dejalo apagado.
                </small>
              </section>
            </app-content-card>
          </mat-step>

          <!-- ── 4. Cliente ───────────────────────────────────────────── -->
          <mat-step [stepControl]="clienteForm" errorMessage="Falta el cliente">
            <ng-template matStepLabel>Cliente</ng-template>
            <app-content-card
              title="Cliente y atención"
              icon="business"
              [formGroup]="clienteForm"
            >
              <div class="client-section-wrapper">
                <div class="client-fields">
                  @if (!clienteFijo) {
                    <section class="inputs-group">
                      <div style="width: 100%">
                        <label class="field-label">Cliente</label>
                        <app-cliente-selector
                          formControlName="idCliente"
                          [filterModules]="[
                            'moduloActivos',
                            'moduloVehiculos',
                            'moduloColectivos',
                          ]"
                          [showCrearBtn]="
                            helper.tienePermiso(
                              'Administración - Crear clientes'
                            )
                          "
                        ></app-cliente-selector>
                      </div>
                    </section>
                  }

                  @if (tipoCliente !== 'Final') {
                    <section class="inputs-group">
                      <div style="width: 100%">
                        <app-config-horarios-atencion
                          formControlName="configHorariosAtencion"
                          [idClienteFinal]="idCliente"
                        ></app-config-horarios-atencion>
                      </div>
                    </section>
                  }

                  <section class="inputs-group">
                    <ng-select
                      [items]="servicios"
                      bindLabel="nombre"
                      bindValue="_id"
                      formControlName="idServiciosContratados"
                      [multiple]="true"
                      placeholder="Servicios contratados"
                      style="width: 100%"
                      appendTo="body"
                      notFoundText="Sin resultados"
                    >
                      <ng-template ng-option-tmp let-item="item">
                        <div class="row-flex-start" style="gap: 8px">
                          @if (item.icono) {
                            <img
                              [src]="item.icono"
                              alt=""
                              class="dashcam-servicio-icono"
                            />
                          }
                          <span>{{ item.nombre }}</span>
                        </div>
                      </ng-template>
                    </ng-select>
                  </section>
                </div>

                @if (idCliente) {
                  <div class="client-hierarchy">
                    <app-jerarquia-cliente
                      [idCliente]="idCliente"
                    ></app-jerarquia-cliente>
                  </div>
                }
              </div>
            </app-content-card>
          </mat-step>
        </mat-stepper>
      </div>
    </form>
  }

  @if (form && stepper) {
    <ng-container actions>
      <button irxBoton="secundario" type="button" (click)="cerrar()">
        Cancelar
      </button>
      <span class="pie-espacio"></span>
      <button
        irxBoton="secundario"
        type="button"
        (click)="stepper.previous()"
        [disabled]="stepper.selectedIndex === 0"
      >
        <mat-icon>chevron_left</mat-icon>
        Anterior
      </button>
      @let ultimo = stepper.selectedIndex === stepper.steps.length - 1;
      <!-- Con el formulario válido, Guardar es la acción principal y
           Siguiente pasa a secundario -->
      @if (!ultimo && form.valid) {
        <button irxBoton="secundario" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      } @else if (!ultimo) {
        <button irxBoton="principal" type="button" (click)="stepper.next()">
          Siguiente
          <mat-icon iconPositionEnd>chevron_right</mat-icon>
        </button>
      }
      <button
        irxBoton="principal"
        type="button"
        (click)="guardar()"
        [disabled]="guardando || form.invalid || canalesRepetidos"
      >
        <mat-icon>save</mat-icon>
        {{ id ? 'Guardar' : 'Crear' }}
      </button>
    </ng-container>
  }
</app-crear-editar>
